import script from "./ModalDetalleActuacionTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDetalleActuacionTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDetalleActuacionTorneo.vue?vue&type=style&index=0&id=d2b4c2bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2b4c2bc"]])

export default __exports__